import { render } from "./InputPercent.vue?vue&type=template&id=80097da8"
import script from "./InputPercent.vue?vue&type=script&lang=js"
export * from "./InputPercent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__